import NotifyMeBtn from './notify-me-button';

class IframeUI {
  constructor(windowData, checkout, selectedVariant, parentPage) {
    this.windowData = windowData;
    this.checkout = checkout;
    this.selectedVariant = selectedVariant;
    this.parentPage = parentPage;
    this.notifyMeBtn = new NotifyMeBtn(parentPage, windowData, selectedVariant);
  }

  start() {
    this._button().addEventListener('click', () => {
      const currentVariant = this.selectedVariant.current();
      const currentShipDates = this.selectedVariant.currentShipDates();

      if (this.windowData.enableCombinedCart === true) {
        this.parentPage.postMessage('combined-cart-button-clicked', {
          shipDates: currentShipDates,
          ...currentVariant,
        });
      } else {
        this.checkout.add(currentVariant);
      }

      this.parentPage.postMessage('button-clicked', {
        instanceId: this.windowData.instanceId,
        ...currentVariant,
      });
    });

    this._loadLearnMore();
    this.notifyMeBtn.mount();

    const state = this.selectedVariant.getState();

    this.parentPage.postMessage('loaded', {
      ...state,
      disabled: !state.checkoutEnabled,
    });
  }

  onNewVariant() {
    const buttonElem = document.querySelector('.purple-dot-button');
    const buttonSpanElem = document.querySelector('.purple-dot-button--text');

    const { checkoutEnabled, isSoldOut, label } =
      this.selectedVariant.getState();
    const { buttonLabels } = this.windowData;

    buttonElem.disabled = !checkoutEnabled;
    buttonSpanElem.innerHTML = isSoldOut
      ? buttonLabels.soldOut
      : buttonLabels.preorder;

    const labelElem = document.querySelector('.label');

    labelElem.innerHTML = label ?? '';

    this.notifyMeBtn.onNewVariant(checkoutEnabled);
  }

  loading() {
    const buttonContentElem = document.querySelector(
      '.purple-dot-button--content'
    );
    buttonContentElem.classList.add('running');
  }

  notLoading() {
    const buttonContentElem = document.querySelector(
      '.purple-dot-button--content'
    );
    buttonContentElem.classList.remove('running');
  }

  showError({ message, isUserRetryable }) {
    const buttonElem = document.querySelector('.purple-dot-button');
    const buttonSpanElem = document.querySelector('.purple-dot-button--text');

    const buttonContentElem = document.querySelector(
      '.purple-dot-button--content'
    );
    buttonContentElem.classList.remove('running');

    if (!isUserRetryable) {
      buttonElem.disabled = true;
      buttonSpanElem.innerHTML = 'Sold out';
    }

    const errMessageElem = document.querySelector('.label');
    errMessageElem.innerHTML =
      message || "We're sorry, your pre-order can't be created";
  }

  _loadLearnMore() {
    const valuePropBtn = document.querySelector('.value-prop');
    valuePropBtn.addEventListener('click', () => {
      this.parentPage.postMessage('value-prop-clicked', {
        productId: this.windowData.productId,
      });
    });
  }

  _button() {
    return document.querySelector('.purple-dot-button');
  }
}

export default IframeUI;
